// src/ride/InvitePassengers.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API_WRK = process.env.REACT_APP_API_WRK; // ✅ e.g. http://localhost:5000/api/worker
const API_BASE = API_WRK?.replace("/api/worker", ""); // ✅ derive full base URL

const InvitePassengers = () => {
  const { rideId } = useParams();
  const [matchingCustomers, setMatchingCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMatches = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/ride/invite-matches/${rideId}`);
        setMatchingCustomers(res.data.matches || []);
      } catch (err) {
        console.error("❌ Failed to fetch matching customers:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchMatches();
  }, [rideId]);

  const handleInvite = async (customerId) => {
    try {
      await axios.post(`${API_BASE}/api/ride/invite`, { rideId, customerId });
      alert("✅ Invitation sent!");
    } catch (err) {
      console.error("❌ Failed to send invite:", err);
      alert("❌ Failed to send invite");
    }
  };

  return (
    <div className="p-6 min-h-screen bg-gray-50">
      <h2 className="text-xl font-bold mb-4 text-gray-800">Matching Customers</h2>

      {loading ? (
        <p>Loading...</p>
      ) : matchingCustomers.length === 0 ? (
        <p className="text-gray-500">No customers looking for this route today.</p>
      ) : (
        <ul className="space-y-4">
          {matchingCustomers.map((c) => (
            <li
              key={c._id}
              className="border p-4 rounded-xl shadow-sm bg-white hover:shadow-md transition"
            >
              <div className="font-semibold text-gray-800">{c.name}</div>
              <div className="text-sm text-gray-600 mt-1">
                Wants ride from <strong>{c.from}</strong> to <strong>{c.to}</strong> on{" "}
                <span className="font-medium text-blue-700">{c.date}</span>
              </div>
              <button
                onClick={() => handleInvite(c._id)}
                className="mt-3 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 text-sm font-medium"
              >
                Invite to Ride
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default InvitePassengers;
